// Smooth Scroll To Anchor
document.querySelectorAll("a[href^=\"#\"]").forEach((anchor) => {
    anchor.addEventListener("click", function (ev) {
      ev.preventDefault();
  
      const targetElement = document.querySelector(this.getAttribute("href"));
      targetElement.scrollIntoView({
        block: "start",
        alignToTop: true,
        behavior: "smooth"
      });
    });
  });

// Leere Seitennavigation entfernen
const sidebar = document.getElementById('sidebar_nav');
if (sidebar) {
    if (sidebar.querySelectorAll('ul > li').length <= 1) {
        sidebar.remove();
    }
}